module.exports = __webpack_public_path__ + "img/wlgk.c475730c.png";